import { Button } from "@/components/ui/button";

export function FormActions({
  saving,
  submitLabel,
  onCancel,
  disabled = false,
}: {
  saving: boolean;
  submitLabel: string;
  onCancel?: () => void;
  /** Keeps the submit button off until the form can be sent. */
  disabled?: boolean;
}) {
  return (
    <div className="mt-1 flex flex-col-reverse gap-2 border-t pt-4 sm:flex-row sm:justify-end">
      {onCancel && (
        <Button variant="outline" onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
      )}
      <Button type="submit" disabled={saving || disabled}>
        {saving ? "Saving…" : submitLabel}
      </Button>
    </div>
  );
}
